import React, { memo } from "react";
import { HeaderWrapper, SubTitleText, TitleText } from "./styles";

export interface IHeader {
    title: string;
    subTitle: string;
}

const Header = ({ title, subTitle }: IHeader) => {
    return (
        <HeaderWrapper>
            <TitleText variant="V2.subheading1.neutral.medium">{title}</TitleText>
            <SubTitleText variant="V2.body3.neutral.regular">{subTitle}</SubTitleText>
        </HeaderWrapper>
    );
};

export default memo(Header);
